module.exports = __webpack_public_path__ + "img/30.100a44fa.jpg";